import React from 'react';
import { urlApi } from '../Constants/Global';
import { Container, Row, Col, Card } from 'react-bootstrap';

import SectionCarousel from '../Components/SectionCarousel';
import SectionContact from '../Components/SectionContact';
import Bg from '../Medias/Photos/photo-1.jpg';
import SectionPractice from '../Components/SectionPractice';
import SectionVision from '../Components/SectionVision';
import SectionNews from '../Components/SectionNews';
import SectionPartner from '../Components/SectionPartner';
import SectionAbout from '../Components/SectionAbout';
import SectionService from '../Components/SectionService';
import SectionTestimonial from '../Components/SectionTestimonial';
import SectionTeam from '../Components/SectionTeam';
import SectionPublication from '../Components/SectionPublication';
import SectionClientCarousel from '../Components/SectionClientCarousel';
import SectionResource from '../Components/SectionResource';
import SectionHomeService from '../Components/SectionHomeService';
import SectionVideoBg from '../Components/SectionVideoBg';
import ContentCarousel from '../Components/ContentCarousel';

import news1_1 from '../Medias/Homes/news1-1.jpg';
import news1_2 from '../Medias/Homes/news1-2.jpg';

import news2_1 from '../Medias/Homes/news2-1.jpg';
import news2_2 from '../Medias/Homes/news2-2.jpg';
import news2_3 from '../Medias/Homes/news2-3.jpg';

import news3_1 from '../Medias/Homes/news3-1.jpg';
import news3_2 from '../Medias/Homes/news3-2.jpg';
import news3_3 from '../Medias/Homes/news3-3.jpg';

import news4_1 from '../Medias/Homes/news4-1.jpg';

import news5_1 from '../Medias/Homes/news5-1.jpg';

import news6_1 from '../Medias/ContentImgs/content_2025-11-23_1.jpg';
import news7_1 from '../Medias/ContentImgs/content_2025-12-03_1.jpg';

import news8_1 from '../Medias/ContentImgs/content_2025-12-21_1.jpg';

import upcoming1_1 from '../Medias/Homes/upcoming1-1.jpg';
import upcoming2_1 from '../Medias/Homes/upcoming2-1.jpg';
import upcoming3_1 from '../Medias/ContentImgs/content_2025-11-23_2.jpg';

const Home = ({ contents }) => {
  console.log(contents)
  const storage = urlApi + '/storage/article/';

  const imgStyle = {
    backgroundSize: 'contain'
  }

  const slides = [
    {
      row_value: Bg,
      detail:
        <>
          <h1 className='tx-color-secondary font-header fw-normal mb-0' style={{ lineHeight: 1.1 }}>Pioneering</h1>
          <h1 className='tx-color-primary font-header fw-normal' style={{ lineHeight: 1.1 }}>Global Legal<br />Excellence</h1>
          {/* <p className='tx-color-primary font-default'>ABER is the FIRST law firm legally accepting cryptocurrencies in Thailand.</p> */}
        </>
    }
  ];

  const news = [
    {
      content: <>
        <Container className='px-0'>
          <Row className='text-center'>
            <Col xs={12} md={4} className='mx-auto mb-2 mb-md-0'>
              <div className='bg-img bg-transparent ratio-16x9' style={{ ...imgStyle, backgroundImage: `url(${news8_1})` }}></div>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col>
              <p>On December 15, 2025, Prapavin Klinchan, Ploykamon Ruengchaisin, and Saran Boonrak participated in the 2025 National Conference on Law and Digital Technology Policy. This two-day event focused on the intersection of law, technology, and regulation in the digital age. Our team had the distinct opportunity to present a research paper on the enforcement of the right to be forgotten under the theme: “From Legal Text to Practical Action.” As commercial transactions occur digitally and globally without regard to physical borders, the enforcement of laws must adapt beyond traditional legal concepts.</p>
            </Col>
          </Row>
        </Container>
      </>
    },
    {
      content: <>
        <Container className='px-0'>
          <Row className='text-center'>
            <Col xs={12} md={4} className='mx-auto mb-2 mb-md-0'>
              <div className='bg-img bg-transparent ratio-16x9' style={{ ...imgStyle, backgroundImage: `url(${news7_1})` }}></div>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col>
              <p>On December 1, 2025, Prapavin Klinchan participated in a meeting at the Designated Areas for Sustainable Tourism Administration (Public Organization) (DASTA) to prepare knowledge-sharing sessions for DASTA staff. We are thrilled to explore the unique opportunities to create a handbook on land use and a handbook on infrastructure investment for DASTA.</p>
            </Col>
          </Row>
        </Container>
      </>
    },
    {
      content: <>
        <Container className='px-0'>
          <Row className='text-center'>
            <Col xs={12} md={4} className='mx-auto mb-2 mb-md-0'>
              <div className='bg-img bg-transparent ratio-16x9' style={{ ...imgStyle, backgroundImage: `url(${news6_1})` }}></div>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col>
              <p>On November 10th, Saran and Ploykanon participated in a meeting at the Green Yellow office in Bangkok to explore how legal solutions can facilitate a renewable energy investment project. Our solutions are designed not only to comply with legal requirements but also to ensure technical and economic viability.</p>
            </Col>
          </Row>
        </Container>
      </>
    },
    {
      content: <>
        <Container className='px-0'>
          <Row className='text-center'>
            <Col xs={12} md={4} className='mx-auto mb-2 mb-md-0'>
              <div className='bg-img bg-transparent ratio-16x9' style={{ ...imgStyle, backgroundImage: `url(${news5_1})` }}></div>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col>
              <p>On October 1, 2025, our team had the opportunity to conduct a customized PDPA training session for over 200 staff members of ThaiNamthip Corporation Public Company Limited (TNT)</p>
            </Col>
          </Row>
        </Container>
      </>
    },
    {
      content: <>
        <Container className='px-0'>
          <Row className='text-center'>
            <Col xs={12} md={4} className='mx-auto mb-2 mb-md-0'>
              <div className='bg-img bg-transparent ratio-16x9' style={{ ...imgStyle, backgroundImage: `url(${news4_1})` }}></div>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col>
              <p>On September 4, 2025, our office assisted in providing PDPA training for staff at the Faculty of Allied Health Sciences (AHSCU), Chulalongkorn University. We are pleased that our analysis and practical legal solutions could support AHSCU’s initiatives in data governance, privacy, and security development.</p>
            </Col>
          </Row>
        </Container>
      </>
    },
    {
      content: <>
        <Container className='px-0'>
          <Row className='text-center'>
            <Col xs={12} md={4} className='mx-auto mb-2 mb-md-0'>
              <div className='bg-img bg-transparent ratio-16x9' style={{ ...imgStyle, backgroundImage: `url(${news1_1})` }}></div>
            </Col>
            <Col xs={12} md={4} className='mx-auto mb-2 mb-md-0'>
              <div className='bg-img bg-transparent ratio-16x9' style={{ ...imgStyle, backgroundImage: `url(${news1_2})` }}></div>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col>
              <p>PT & Associates (PTA) represented by Dr. Piti Eiamchamroonlarp, Senior Lawyer Preecha Lertassavavivat, and Junior Lawyer Saran Boonrak presented their research paper utilizing multi-jurisdictional legal analysis on the novel topic of congestion charges in Thailand before the Bangkok Metropolitan Administration (BMA). The PTA team is honored to have Bangkok Governor Chadchart Sittipunt attend the presentation and discussions, as well as executives from Yunex Traffic, a global leader in intelligent traffic systems. (Bangkok Metropolitan Administration City Hall, Bangkok, Thailand on 21 July 2025)</p>
            </Col>
          </Row>
        </Container>
      </>
    },
    {
      content: <>
        <Container className='px-0'>
          <Row className='text-center'>
            <Col xs={12} md={4} className='mx-auto mb-2 mb-md-0'>
              <div className='bg-img bg-transparent ratio-16x9' style={{ ...imgStyle, backgroundImage: `url(${news2_1})` }}></div>
            </Col>
            <Col xs={12} md={4} className='mx-auto mb-2 mb-md-0'>
              <div className='bg-img bg-transparent ratio-16x9' style={{ ...imgStyle, backgroundImage: `url(${news2_2})` }}></div>
            </Col>
            <Col xs={12} md={4} className='mx-auto mb-2 mb-md-0'>
              <div className='bg-img bg-transparent ratio-16x9' style={{ ...imgStyle, backgroundImage: `url(${news2_3})` }}></div>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col>
              <p>Rahat Alikhan (Project Development Consultant, Lighthouse Asia Consulting) and Benjamin Sa-Ong Luis (Senior Consultant, PT & Associates) gave special lectures to the incoming cohort of Master of Laws in Business Law (International Program) of Chulalongkorn University on how to survive and thrive in this program, while showing the versatile range of future career prospects open to program alumni. The event was attended by students from five different countries. (Dusit Thani Pattaya Hotel, Thailand on 20 July 2025)</p>
            </Col>
          </Row>
        </Container>
      </>
    },
    {
      content: <>
        <Container className='px-0'>
          <Row className='text-center'>
            <Col xs={12} md={4} className='mx-auto mb-2 mb-md-0'>
              <div className='bg-img bg-transparent ratio-16x9' style={{ ...imgStyle, backgroundImage: `url(${news3_1})` }}></div>
            </Col>
            <Col xs={12} md={4} className='mx-auto mb-2 mb-md-0'>
              <div className='bg-img bg-transparent ratio-16x9' style={{ ...imgStyle, backgroundImage: `url(${news3_2})` }}></div>
            </Col>
            <Col xs={12} md={4} className='mx-auto mb-2 mb-md-0'>
              <div className='bg-img bg-transparent ratio-16x9' style={{ ...imgStyle, backgroundImage: `url(${news3_3})` }}></div>
            </Col>
          </Row>
          <Row className='mt-3'>
            <Col>
              <p>Dr. Piti Eiamchamroonlarp participated as the subject matter expert on Thai energy law during the roundtable discussions on the theme of “Unlocking Wind Potential in Thailand” organized by the Thai Wind Energy Association and Informa Markets during the Asia Sustainable Energy Week held on 2 July 2025 at the Queen Sirikit National Convention Center, Bangkok, Thailand.</p>
            </Col>
          </Row>
        </Container>
      </>
    },
  ];
  const upcomings = [
    {
      content: <>
        <Container className='px-0'>
          <Row>
            <Col xs={12} md={4} className='mb-3 mb-md-0'>
              <img src={upcoming3_1} className='w-100' />
            </Col>
            <Col>
              <p>On November 27, 2025, Dr. Piti Eiamchamroonlarp will be a speaker at Super Session 1 during the IEEE PES GTD Conference and Exposition Asia 2025. His presentation will explore the legal aspects of "Ancillary Services and Technologies: Opportunities for Thailand's Power Grid."</p>
            </Col>
          </Row>
        </Container>
      </>
    },
    {
      content: <>
        <Container className='px-0'>
          <Row>
            <Col xs={12} md={4} className='mb-3 mb-md-0'>
              <img src={upcoming2_1} className='w-100' />
            </Col>
            <Col>
              <p>Dr. Piti Eiamchamroonlarp will be sharing legal recommendations and analyzes to ensure that a construction contract between a state agency and a private party is simultaneousely lawful, fair and bankable. The event will be held by the Engineering Institute of Thailand on 1 to 2 of August 2025.</p>
            </Col>
          </Row>
        </Container>
      </>
    },
    {
      content: <>
        <Container className='px-0'>
          <Row>
            <Col xs={12} md={4} className='mb-3 mb-md-0'>
              <img src={upcoming1_1} className='w-100' />
            </Col>
            <Col>
              <p>Dr. Piti Eiamchamroonlarp will be giving a lecture during the Thailand Electricity Producer conference organized by The Association of Private Power Producers, and the Electricity Generating Authority of Thailand (EGAT) to be held on 5-6 September 2025 at The Bonanza Resort Khao Yai Hotel, Amphoe Pak Chong, Chang Wat Nakhon Ratchasima, Thailand.</p>
            </Col>
          </Row>
        </Container>
      </>
    },
  ];

  const videoOverlayContent = <>
    <div className='text-white position-relative'>
      <Container>
        <Row>
          <Col>
            <h1 className='font-header'>PT & Associates</h1>
            <h3>Creative Legal Strategies</h3>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>Our boutique law firm PT & Associates (PTA) is known for its multi-disciplinary perspectives for solving legal and regulatory challenges for our clients in the energy industry both in the private and government sectors. Our professional team brings expertise from diverse academic and industry backgrounds to formulate and implement legal strategies that address our clients’ business needs. Our services consist of inventive legal solutions tailored to deliver client-determined optimal results.
          </Col>
          <Col xs={12} md={6} className='mt-3 mt-md-0'>Beyond providing legal services, PTA maintains the not-for-profit Energy Law Center (ELC) with the generous support of corporate social responsibility (CSR) donors who share our vision of creating an open and neutral platform for energy law scholarship and discussions. The ELC serves as a forum for community outreach — supporting news and events, regulatory updates, energy education and trends, and publications — that provides general information to various stakeholders to understand the economic and social value of energy law.
          </Col>
        </Row>

        <Row className='mt-5 mb-5'>
          <Col xs={12} md={7} className='mb-3 mb-md-0'>
            <Card className='home-slide-content border-0' style={{ backgroundColor: 'rgba(255, 255, 255, 0.4)' }}>
              <Card.Body className='p-4 px-5'>
                <h5 className='font-header mb-3'>Featured Bulletins and Updates</h5>
                <ContentCarousel contents={news} />
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={5} className='mb-3 mb-md-0'>
            <Card className='home-slide-content border-0' style={{ backgroundColor: 'rgba(255, 255, 255, 0.4)' }}>
              <Card.Body className='p-4 px-5'>
                <h5 className='font-header mb-3'>Upcoming Events</h5>
                <ContentCarousel contents={upcomings} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  </>;

  return (
    <>
      <SectionVideoBg contents={contents} videoContent={videoOverlayContent} />
      {/* <ContentDisplay contents={contents?.content?.contents} storage={storage} lang={contents.lang} /> */}
      {/* <SectionCarousel contents={slides} />
      <SectionAbout contents={contents?.web_setup?.about} />
      <SectionHomeService contents={contents?.web_setup?.about} /> */}
      {/* <SectionService contents={contents?.web_setup?.services} /> */}
      {/* <SectionTestimonial />
      <SectionTeam />
      <SectionResource contents={contents?.web_setup?.publication} youtubes={contents?.web_setup?.youtube} />
      <SectionNews contents={contents?.articles} />
      <SectionContact contents={contents} /> */}
    </>
  )
}

Home.defaultProps = {
  contents: {
    lang: 'th',
    content: {
      contents: []
    }
  },
  web_setup: {
    practice_topic: [],
    practice: []
  },
  path: '',
  lang: 'en'
}

export default Home